class UpgradeToSet extends HTMLElement {
    constructor() {
      super();

      this.variantId = this.getAttribute('data-variant-id');
      this.quickAddBtn = this.querySelector('quick-add-button');
    }
  
    connectedCallback() {
      this.addEventListener("click", this.upgradeToSet.bind(this));
    }
  
    async upgradeToSet({ currentTarget }) {
        currentTarget.querySelector("[js-upgrade-btn]").textContent = "upgrading...";
        try {
            const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: this.variantId,
                quantity: 0,
            }),
            });
    
            await response.json();
            if (response.ok) {
                this.quickAddBtn.dispatchEvent(new Event('click'));
            }
        } catch (error) {
            console.error("Error during upgrade to set:", error);
        }
    }
}
  
customElements.define("upgrade-to-set", UpgradeToSet);
  